import { theme } from '@Guidelines/Theme/theme';
import AddDocumentControl from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/StagesSection/AddDocumentControl';
import DocumentRow from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/StagesSection/StageCard/DocumentRow';
import StageCardActions from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Sections/StagesSection/StageCard/StageCardActions';
import type DocumentSettingsFormData from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/FormData/DocumentSettingsFormData';
import { css } from '@emotion/react';
import type * as React from 'react';

const stageStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	padding: 1rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
`;

const headerStyle = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.625rem;
	flex-wrap: wrap;
`;

const titleStyle = css`
	margin: 0;
	font-family: ${theme.fonts.display};
	font-size: 1rem;
	font-weight: ${theme.fontWeights.semibold};
	line-height: 1.2;
	color: ${theme.colors.ink};
`;

type Props = {
	readonly stageIndex: number;
	readonly stage: readonly DocumentSettingsFormData[];
};

/** One stage: its rank, its documents generated in parallel, and the way to add another one. */
const StageCard: React.FC<Props> = ({ stageIndex, stage }) => {
	return (
		<div css={stageStyle}>
			<div css={headerStyle}>
				<h3 css={titleStyle}>Étape {stageIndex + 1}</h3>
				<StageCardActions stageIndex={stageIndex} />
			</div>
			{stage.map((document, stepIndex) => (
				<DocumentRow
					key={document.documentTypeId ?? `new-${stepIndex}`}
					stageIndex={stageIndex}
					stepIndex={stepIndex}
					document={document}
				/>
			))}
			<AddDocumentControl stageIndex={stageIndex} />
		</div>
	);
};

export default StageCard;
